if (!customElements.get('seolab-feature-toolkit')) {
  customElements.define('seolab-feature-toolkit', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabList = this.querySelector('[role="tablist"]');
      if (!this.tabs.length || !this.tabList) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.tabs.findIndex(tab => tab.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index);
      }, options);
      this.measure();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.measure());
        // Watch natural text sizes, not the animated wrappers, to avoid resize loops.
        this.tabs.forEach(tab => {
          this.resizeObserver.observe(tab);
          this.resizeObserver.observe(tab.closest('.sft__tab').querySelector('.sft__description'));
        });
      } else {
        window.addEventListener('resize', () => this.measure(), options);
      }
      document.fonts?.ready.then(() => {
        if (this.isConnected) this.measure();
      });
    }

    measure() {
      if (!this.tabList || !this.tabs.length) return;
      let descriptionHeight = 0;
      let buttonHeight = 0;
      this.tabs.forEach(tab => {
        descriptionHeight = Math.max(descriptionHeight, tab.closest('.sft__tab').querySelector('.sft__description').getBoundingClientRect().height);
        buttonHeight += tab.getBoundingClientRect().height;
      });
      const gap = parseFloat(getComputedStyle(this.tabList).rowGap) || 0;
      this.tabList.style.setProperty('--sft-description-height', Math.ceil(descriptionHeight) + 'px');
      this.tabList.style.height = Math.ceil(buttonHeight + descriptionHeight + gap * (this.tabs.length - 1)) + 'px';
    }

    select(index) {
      if (!this.tabs[index]) return;
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const wrapper = tab.closest('.sft__tab');
        wrapper.dataset.active = String(active);
        const description = wrapper.querySelector('.sft__description-wrap');
        description.setAttribute('aria-hidden', String(!active));
        description.inert = !active;
      });
      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.dataset.active = String(active);
        panel.setAttribute('aria-hidden', String(!active));
        panel.tabIndex = active ? 0 : -1;
        panel.inert = !active;
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
